import React, { useState } from 'react';
import { useRaceStore } from '../../stores/raceStore';
import { useTranslation } from '../../utils/i18n';
import { Card, CardContent } from '../ui/Card';
import { Button } from '../ui/Button';
import { CalibrationWizard } from './CalibrationWizard';
import { UserIcon, RefreshCwIcon, ActivityIcon, MountainIcon, ThermometerIcon, DropletsIcon } from 'lucide-react';
export function AthleteProfileSection() {
  const {
    t
  } = useTranslation();
  const {
    settings,
    updateAthleteCalibration
  } = useRaceStore();
  const [showWizard, setShowWizard] = useState(false);
  const {
    answers,
    params
  } = settings.athleteProfile;
  const Stat = ({
    label,
    value,
    icon: Icon
  }: {
    label: string;
    value: string;
    icon: any;
  }) => <div className="flex items-center gap-3 p-3 rounded-xl bg-[#F7F7FA] border border-[#E8E8ED]" data-id="element-922">
      <div className="p-2 bg-white rounded-lg border border-[#E8E8ED] text-[#6B6B76]" data-id="element-923">
        <Icon className="h-4 w-4" data-id="element-924" />
      </div>
      <div data-id="element-925">
        <p className="text-xs font-semibold text-[#9B9BA7] uppercase tracking-wider" data-id="element-926">
          {label}
        </p>
        <p className="text-sm font-bold text-[#2D2D2D] capitalize" data-id="element-927">{value}</p>
      </div>
    </div>;
  // Generate dynamic insights
  const insights = [];
  if (answers.heatTolerance === 'sensitive') {
    insights.push(t('athlete.insightHeat'));
  }
  if (answers.sweatRate === 'heavy') {
    insights.push(t('athlete.insightSweat'));
  }
  if (answers.fatigue === 'early') {
    insights.push(t('athlete.insightFatigue'));
  }
  if (answers.riskTolerance === 'finish') {
    insights.push(t('athlete.insightRisk'));
  }
  return <div className="bg-white rounded-2xl border border-[#E8E8ED] shadow-sm overflow-hidden" data-id="element-928">
      <div className="px-5 py-3.5 border-b border-[#E8E8ED] flex items-center justify-between" data-id="element-929">
        <div className="flex items-center gap-2.5" data-id="element-930">
          <UserIcon className="h-5 w-5 text-[#FC4C02]" data-id="element-931" />
          <span className="text-base font-bold text-[#2D2D2D]" data-id="element-932">
            {t('athlete.title')}
          </span>
        </div>
        <Button variant="outline" size="sm" onClick={() => setShowWizard(true)} data-id="element-933">
          <RefreshCwIcon className="h-3.5 w-3.5 mr-2" data-id="element-934" />
          {t('athlete.recalibrate')}
        </Button>
      </div>

      <div className="p-5 space-y-4" data-id="element-935">
        <p className="text-sm text-[#6B6B76]" data-id="element-936">{t('athlete.subtitle')}</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4" data-id="element-937">
          <Stat label={t('athlete.flatEffort')} value={answers.flatEffort === 'sub530' ? t('athlete.fast') : answers.flatEffort} icon={ActivityIcon} data-id="element-938" />
          <Stat label={t('athlete.uphillStrategy')} value={answers.uphillStrategy.replace(/([A-Z])/g, ' $1').trim()} icon={MountainIcon} data-id="element-939" />
          <Stat label={t('athlete.heatTolerance')} value={answers.heatTolerance} icon={ThermometerIcon} data-id="element-940" />
          <Stat label={t('athlete.sweatRate')} value={answers.sweatRate} icon={DropletsIcon} data-id="element-941" />
        </div>

        {insights.length > 0 && <div className="bg-[#F0F9FF] border border-[#BAE6FD] rounded-xl p-4" data-id="element-942">
            <h4 className="text-sm font-bold text-[#0C4A6E] mb-2" data-id="element-943">
              {t('athlete.insightsTitle')}
            </h4>
            <ul className="space-y-1" data-id="element-944">
              {insights.map((insight, idx) => <li key={idx} className="text-xs text-[#0284C7] flex items-start gap-2" data-id="element-945">
                  <span className="mt-1 w-1 h-1 rounded-full bg-[#0284C7] shrink-0" data-id="element-946" />
                  {insight}
                </li>)}
            </ul>
          </div>}

        {showWizard && <CalibrationWizard initialAnswers={answers} onSave={newAnswers => {
        updateAthleteCalibration(newAnswers);
        setShowWizard(false);
      }} onCancel={() => setShowWizard(false)} data-id="element-947" />}
      </div>
    </div>;
}